var exports = {
  "ZK": "ChannelFollowSuccessModal.module__hero___SE9lcU",
  "Wp": "ChannelFollowSuccessModal.module__patternImage___SE9lcU",
  "RG": "ChannelFollowSuccessModal.module__composition___SE9lcU",
  "Dr": "ChannelFollowSuccessModal.module__sourceIconWrap___SE9lcU",
  "$f": "ChannelFollowSuccessModal.module__guildIcon___SE9lcU",
  "hI": "ChannelFollowSuccessModal.module__announcementBadge___SE9lcU",
  "aw": "ChannelFollowSuccessModal.module__announcementBadgeIcon___SE9lcU",
  "UE": "ChannelFollowSuccessModal.module__arrow___SE9lcU",
  "rf": "ChannelFollowSuccessModal.module__body___SE9lcU",
  "DD": "ChannelFollowSuccessModal.module__title___SE9lcU",
  "h_": "ChannelFollowSuccessModal.module__description___SE9lcU",
};

module.exports = exports;
